import { useProjects } from "@hq/client-react";
import type { PaneComponentProps } from "@hq/layout";
import { ProjectTasksView } from "@hq/tasks-ui";
import { useEffect } from "react";
import { useWorkspace } from "../workspace/WorkspaceContext";

export function ProjectPane({ pane }: PaneComponentProps) {
  const ws = useWorkspace();
  const projectId = String(pane.params.projectId);
  const { data: projects } = useProjects();
  const name = projects?.find((p) => p.id === projectId)?.name;

  useEffect(() => {
    if (name !== undefined && name !== pane.title) ws.setTitle(pane.id, name);
  }, [name, pane.id, pane.title, ws]);

  return (
    <ProjectTasksView
      projectId={projectId}
      onOpenTask={ws.openTask}
      className="h-full overflow-y-auto px-6 py-7"
    />
  );
}
